import { Component, OnInit, Inject } from '@angular/core';
import { CertificationRequest, CertificationsService, CertificationRequestStatus } from '@eemo/api-client';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { AlertService } from '@/services/alert.service';
import { CertificationHelper } from '@/helpers/certification.helper';
import { HttpErrorResponse } from '@angular/common/http';

import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

export class CertificationRequestUpdateDialogData {
  request: CertificationRequest;
}

@Component({
    selector: 'app-certification-request-update-dialog',
    templateUrl: './certification-request-update-dialog.component.html',
    styleUrls: ['./certification-request-update-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, MatInputModule, NgIf, MatButtonModule]
})
export class CertificationRequestUpdateDialogComponent implements OnInit {
  requestForm: UntypedFormGroup;
  dialogTitle: string;
  formSubmitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CertificationRequestUpdateDialogData,
    private certificationService: CertificationsService,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
    public certificationHelper: CertificationHelper,
    public dialogRef: MatDialogRef<CertificationRequestUpdateDialogComponent>
  ) {
    this.dialogTitle = 'Modifier la demande';
  }

  // convenience getter for easy access to form fields
  f(field: string): AbstractControl {
    return this.requestForm.get(field);
  }

  ngOnInit() {
    this.requestForm = this.fb.group({
      status: ['IN_PROGRESS', Validators.required],
      message: ['', Validators.maxLength(160)]
    });

    if (this.data.request) {
      this.requestForm.patchValue(this.data.request);
    }
  }

  onSubmit() {
    if (this.requestForm.valid) {
      this.formSubmitting = true;
      this.data.request.status = this.f('status').value;
      this.data.request.message = this.f('message').value;
      this.certificationService.updateCertificationRequest(this.data.request.uid, this.data.request).subscribe(
        (result) => {
          this.dialogRef.close(true);
          this.alertService.success('Mise à jour effectuée');
        },
        (err: HttpErrorResponse) => {
          this.dialogRef.close();
        }
      );
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
